var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.56 21.63a.76.76 0 0 0-.78-.78c-.4 0-.78.37-.78.78 0 .42.33.79.78.79s.78-.34.78-.79zM41 26.6v3.05c0 .74-.56 1.04-1.15 1.04h-2.54A2.44 2.44 0 0 1 34.87 33c-1.3 0-2.37-1-2.47-2.3h-8.87a2.44 2.44 0 0 1-4.87 0h-1.33c-.92 0-1.07-.45-1.07-1.04V26.7c0-.52.04-.89.3-1.41l2.58-5.14A2.12 2.12 0 0 1 20.92 19h9.82c.7 0 1.36.44 1.77 1.16l2.33 3.83 4.68 1.04c1.22.2 1.44.93 1.48 1.57zm-18.54 3.83a1.33 1.33 0 1 0-2.65 0 1.33 1.33 0 1 0 2.65 0zm2.66-9.98H21.5c-.6.04-.85.26-1.19.9l-1.14 2.6h5.94v-3.5zm7.79 3.5l-1.56-2.6c-.3-.5-.73-.9-1.4-.9h-3.29v3.5h6.25zm3.29 6.48a1.3 1.3 0 0 0-1.3-1.34c-.73 0-1.32.6-1.32 1.34 0 .74.59 1.34 1.32 1.34.7 0 1.3-.59 1.3-1.34zm-24.74-7.1c-.04-.16-.08-.27-.08-.45 0-.74.6-1.34 1.33-1.34.74 0 1.36.6 1.36 1.38 0 .52-.3 1-.78 1.19.34.37.52.9.52 1.42 0 .19-.03.37-.07.56.82.04 1.44.7 1.44 1.53a1.5 1.5 0 0 1-1.5 1.52c-.82 0-1.49-.67-1.52-1.5-.2.05-.33.08-.52.08a2.2 2.2 0 0 1-2.18-2.2c0-1.15.88-2.12 2-2.2z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: ".98"
  })));
});